import { ReactNode } from "react";

export interface ListProps<T extends string> {
    items: Partial<Record<T, ReactNode>>;
    callback?: (key: T) => void;
    testId?: string;
}

export const List = <T extends string>({ items, callback }: ListProps<T>) => {
    return (
        <>
            {Object.keys(items).map((key, index) => {
                return (
                    <div
                        key={index}
                        onClick={() => callback && callback(key as T)}
                        className="overflow-hidden cursor-pointer whitespace-nowrap focus:bg-irBlue-100"
                        tabIndex={0}
                        onKeyDown={(e) => {
                            if (e.key !== "Enter") return;
                            callback && callback(key as T);
                        }}
                    >
                        {items[key as T]}
                    </div>
                );
            })}
        </>
    );
};
